import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

// Fragments
import './fragments/homeServiceOrderProviderFragment';

export const unassignHomeServiceOrderProvider = async (id: number) => {
  const response = await mutationExecute({
    variables: {
      id,
    },
    mutation: graphql(`
      mutation UnassignHomeServiceOrderProvider($id: Float!) {
        unassignHomeServiceOrderProvider(id: $id) {
          ...HomeServiceOrderProviderFragment
        }
      }
    `),
  });

  return !!response.data?.unassignHomeServiceOrderProvider;
};
